<p-dialog 
  [modal]="true" 
  [(visible)]="visible"
  [styleClass]="'modern-dialog'"
  [contentStyleClass]="'modern-dialog-content'"
>
  <ng-template pTemplate="header">
    <h2 class="dialog-title">{{modalDialog?.title | translate}}</h2>
  </ng-template>
  <ng-template pTemplate="content">
    <p class="dialog-message">{{modalDialog?.message | translate}}</p>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <p-button 
        label="{{'i18n.shared.cancel' | translate}}" 
        styleClass="p-button-text" 
        (onClick)="cancelClicked()"
      />
      <p-button 
        label="{{'i18n.shared.ok' | translate}}" 
        styleClass="p-button-raised p-button-primary" 
        (onClick)="okClicked()"
      />
    </div>
  </ng-template>
</p-dialog>

